export const MAP_ZOOM_LEVEL = 17;
export const DEFAULT_ANIMATION_DURATION = 1000;